import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import NavTabs, { NavTab } from 'shared/components/NavTabs';
import { pathPatternMatch } from 'shared/components/makeNav';
import { navigationOptions } from 'shared/account/pages/MoreOptions';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

export default function DonorNavTabs() {
  const { pathname } = useLocation();

  return (
    <NavTabs>
      {navigationOptions.donor.primary.map(tab => {
        const isStrategy = tab.value === '/donor/strategy';
        const label = isStrategy ? (
          <TabLabel>
            {tab.label}
            <BetaPill active={pathPatternMatch(pathname, tab.value)}>
              BETA
            </BetaPill>
          </TabLabel>
        ) : (
          tab.label
        );

        return <NavTab key={tab.value} value={tab.value} label={label} />;
      })}
    </NavTabs>
  );
}

const TabLabel = styled.span`
  display: inline-flex;
  align-items: center;
`;

const BetaPill = styled.span<{ active: boolean }>`
  display: inline-flex;
  align-items: center;
  /* keep the pill from affecting the tab height */
  margin-left: 6px;
  padding: 1px 6px;
  border: 1px solid;
  border-radius: 999px;
  font-size: 9.5px;
  font-weight: 700;
  line-height: 1;
  color: ${({ active }) => (active ? COLORS.ctaPrimary : COLORS.grayDark)};
`;
